"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTING_TYPE = void 0;
exports.SORTING_TYPE = {
    ASC: 'ASC',
    DESC: 'DESC',
};
//# sourceMappingURL=sortingType.js.map